import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";

import es from "javascript-time-ago/locale/es";
import ru from "javascript-time-ago/locale/ru";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/es";

import footer_es from "./translations/es/footer.json";
import footer_en from "./translations/en/footer.json";

import { setupGlobalAxios } from './services/axiosGlobalConfig';
import { getPwaKey } from './config/pwaScopes';
import { registerPwa } from './pwa/registerPwa';

setupGlobalAxios();
registerPwa();

// Configurar TimeAgo
TimeAgo.addDefaultLocale(es);
TimeAgo.addLocale(ru);

// Configurar i18next
i18next.init({
  interpolation: { escapeValue: false },
  lng: localStorage.getItem("lng") || "es",
  resources: {
    es: { footer: footer_es },
    us: { footer: footer_en },
  },
});

// Filtrar warnings específicos de ResizeObserver
const resizeObserverWarning =
  "ResizeObserver loop completed with undelivered notifications";
const filterConsole =
  (originalFn) =>
  (...args) => {
    const msg = typeof args[0] === "string" ? args[0] : "";
    if (msg.includes(resizeObserverWarning)) return;
    originalFn(...args);
  };

console.error = filterConsole(console.error);
console.warn = filterConsole(console.warn);

// Cada app (dashboard, montacargas, cooler) se carga como un chunk aparte y se
// elige UNA sola vez según el path. Así, en /cooler no se descarga ni se
// monta el código del dashboard ni de montacargas, y viceversa.
const entries = {
  dashboard: () => import("./entries/dashboard"),
  montacargas: () => import("./entries/montacargas"),
  cooler: () => import("./entries/cooler"),
};

const root = ReactDOM.createRoot(document.getElementById("root"));

entries[getPwaKey()]().then(({ default: Entry }) => {
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18next}>
        <Entry />
      </I18nextProvider>
    </React.StrictMode>,
  );
});
